export const burl = window.location.origin;
